import { render, staticRenderFns } from "./deanInputSlider.vue?vue&type=template&id=3a6ad060&scoped=true"
import script from "./deanInputSlider.vue?vue&type=script&lang=ts"
export * from "./deanInputSlider.vue?vue&type=script&lang=ts"
import style0 from "./deanInputSlider.vue?vue&type=style&index=0&id=3a6ad060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6ad060",
  null
  
)

export default component.exports